import React, { useState } from 'react';
import Head from 'next/head';
import NavBar from '../components/Navbar/navbar';
import SendSupportEmail from '../components/SendSupportEmail';

const UserSupportPage = () => {
    const [isModalVisible, setModalVisible] = useState(false);
    
    const toggleModal = () => {
        setModalVisible(!isModalVisible);
      };
    
    
    
        const topHalf: React.CSSProperties = {
          height: '45%', // Height is 45% of its parent container
          width: '100%', // Width takes the full width of its parent container
          padding: '10px', // Adds small padding around the content, adjust as needed
          display: 'flex', // Using flexbox to center contents
          justifyContent: 'center', // Horizontally center the content
          alignItems: 'center', // Vertically center the content
        };
    
        const bottomHalf: React.CSSProperties = {
          height: '55%', // Height is 45% of its parent container
          width: '100%', // Width takes the full width of its parent container
          padding: '10px', // Adds small padding around the content, adjust as needed
          display: 'flex', // Using flexbox to center contents
          justifyContent: 'center', // Horizontally center the content
          alignItems: 'center', // Vertically center the content
          flexDirection: 'column'
        };
        
        
    
      const overlayStyle: React.CSSProperties = {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
          zIndex: 99
      }

  return (
    <>
      <Head>
        <title>Naitram Support</title>
        <link rel="icon" href="/assets/Naitram.png" type="image/png" />
      </Head>
      <style global jsx>{`
        body, html {
          height: 100%;
          margin: 0;
          font-family: Arial, sans-serif;
          background-color: #e6ffe6; /* Light green background */
          color: #333;
        }

        .my-container {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          text-align: center;
          min-height: 100vh; /* Full viewport height */
          padding: 20px;
          width: 100vw;
          margin-top: 50px; /* Added margin top */
        }

        h1 {
          color: darkblue;
          margin-bottom: 30px;
          font-size: 45px;
        }

        p {
          color: #ffffff;
          font-size: 24px;
          font-weight: bold;
        }

        form {
          background: linear-gradient(135deg, #012030 0%, #004080 100%);
          padding: 20px;
          border: 1px solid #ccc;
          border-radius: 10px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          width: 80%;
          max-width: 600px;
          display: flex;
          flex-direction: column;
          align-items: flex-start; /* Align items to the start */
        }

        .input-container {
          display: flex;
          width: 100%;
          margin-top: 10px;
        }

        input {
          flex: 1;
          font-size: 18px;
          padding: 10px;
          border: 1px solid #ccc;
          border-radius: 5px 0 0 5px; /* Rounded corners for the left side */
        }

        .submit-container {
          display: flex;
          justify-content: flex-end;
          width: 100%;
        }

        button {
          background-color: darkblue;
          color: white;
          border: none;
          padding: 10px 20px;
          margin: 10px 0;
          cursor: pointer;
          border-radius: 0 5px 5px 0; /* Rounded corners for the right side */
          font-size: 18px;
        }
        @media (max-width: 440px) {
            h1 {
              color: darkblue;
              margin-bottom: 30px;
              font-size: 35px;
            }
            form {
              width: 95%;
            }
          }
      `}</style>

      <NavBar />
      <div className="my-container">
        <h1>Contact Naitram Support</h1>
        <form>
          <p>Please write out your question or issue below and our team will be in touch within 24 hours</p>
          <SendSupportEmail setModalVisible={setModalVisible}/>
        </form>
              {/* Modal */}
              {isModalVisible && (
        <>
          <div style={overlayStyle} onClick={toggleModal}></div>
          <div className="edit-bottom-modal">
            <div style={topHalf}>
            <svg width="140" height="140" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="white"/>
            </svg>

            </div>


            <div style={bottomHalf}>
            <p>You have successfully sent the message</p>
            </div>

          </div>
        </>
      )}
      </div>
    </>
  );
};

export default UserSupportPage;
